module.exports = __webpack_public_path__ + "static/media/Podmoli.91faacb5.md";